// Маркер «это PWA/поток курьера» — редирект с / в standalone, см. LandingPage
export const STAFF_PWA_KEY = 'tez_staff_pwa';
export const STAFF_PWA_COURIER = 'courier';
